const globals = JSON.parse(atob(window.envKey));

export default globals;